import Swiper, {
  Navigation,
  Pagination,
  FreeMode,
  Thumbs,
  EffectCreative,
  Autoplay,
  EffectCoverflow
} from 'swiper';

Swiper.use([
  Navigation,
  Pagination,
  FreeMode,
  Thumbs,
  EffectCreative,
  Autoplay,
  EffectCoverflow
]);

window.Swiper = Swiper;